import {html} from '@isceco/widget-library2/external/lit'
import {repeat} from '@isceco/widget-library2/external/lit/directives/repeat'
import '@isceco/widget-library2/basic-elements/Title/Title'
import '@isceco/widget-library2/basic-elements/Card/Card'
import '@isceco/widget-library2/basic-elements/Button/Button'
import '@isceco/widget-library2/basic-elements/Form/Form'
import '@isceco/widget-library2/basic-elements/TextInput/TextInput'
import '@isceco/widget-library2/basic-elements/Textarea/Textarea'
import '@isceco/widget-library2/basic-elements/NumberInput/NumberInput'
import '@isceco/widget-library2/basic-elements/Dropdown/Dropdown'
import '@isceco/widget-library2/basic-elements/FileInput/FileInput'
import FDRService from './FDRService'
import FormComponent from '../../../../components/FormComponent'

export default class FDR extends FormComponent {
  constructor() {
    super()
    this.propertyAddedStreets = []
  }

  get translationFile() {
    return './views/WBF/BWO/FDR/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  getTemplate() {
    const submitKey = this.preview ? 'form.button.submit' : 'form.button.preview'
    return html`
      <isceco-title id="page-title"
                    text="${this.i18n.translate('page.title')}"
      ></isceco-title>
      <eform-submit-status></eform-submit-status>
      <isceco-form id="fdr-form"
                   include-disabled
                   submit-button-text="${this.i18n.translate(submitKey)}"
                   @submit="${e => this._submit(e)}">

        <div slot="buttons">
          <isceco-button text="${this.i18n.translate('form.button.abort')}"
                         @click="${() => this.abort()}"
                         variant="secondary"
                         .disabled="${!this.preview}"
          ></isceco-button>
        </div>

        <div slot="form-elements" class="form-elements">
          ${this.getFormElements()}
        </div>

      </isceco-form>
    `
  }

  getFormElements = () => {
    return html`
      <isceco-card text="${this.i18n.translate('form.title.applicant')}" class="form-card">
        <isceco-text-input label="${this.i18n.translate('form.input.applicant.name')}"
                           name="applicant.name"
                           required
                           .readonly="${this.preview}"
        ></isceco-text-input>
        <div class="single-line">
          <isceco-text-input label="${this.i18n.translate('form.input.applicant.street')}"
                             name="applicant.street"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 0.6"
          ></isceco-text-input>
          <isceco-text-input label="${this.i18n.translate('form.input.applicant.houseNo')}"
                             name="applicant.houseNo"
                             .readonly="${this.preview}"
                             style="flex-grow: 0.4"
          ></isceco-text-input>
        </div>
        <div class="single-line">
          <isceco-number-input label="${this.i18n.translate('form.input.applicant.zip')}"
                               name="applicant.zipCode"
                               required
                               min="1000"
                               max="9999"
                               maximum-fraction-digits="0"
                               .readonly="${this.preview}"
          ></isceco-number-input>
          <isceco-text-input label="${this.i18n.translate('form.input.applicant.city')}"
                             name="applicant.city"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 1"
          ></isceco-text-input>
        </div>
      </isceco-card>

      <isceco-card text="${this.i18n.translate('form.title.property')}" class="form-card">
        <div class="single-line">
          <isceco-text-input label="${this.i18n.translate('form.input.property.street')}"
                             name="property.street"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 0.6"
          ></isceco-text-input>
          <isceco-text-input label="${this.i18n.translate('form.input.property.houseNo')}"
                             name="property.houseNo"
                             .readonly="${this.preview}"
                             style="flex-grow: 0.4"
          ></isceco-text-input>
          <isceco-button variant="primary" icon="plus"
                         ?disabled="${(this.propertyAddedStreets.length > 3)}"
                         @click="${() => this._addPropertyStreet()}"
                         style="display: ${this.preview ? 'none' : 'block'}; margin-top: 23px"
          ></isceco-button>
        </div>
        ${repeat(this.propertyAddedStreets, street => street.renderId, (street, index) => html`
          <div class="single-line">
            <isceco-text-input label="${this.i18n.translate('form.input.property.street')}"
                               name="property.street${street.renderId}"
                               required
                               .readonly="${this.preview}"
                               style="flex-grow: 0.6"
            ></isceco-text-input>
            <isceco-text-input label="${this.i18n.translate('form.input.property.houseNo')}"
                               name="property.houseNo${street.renderId}"
                               .readonly="${this.preview}"
                               style="flex-grow: 0.4"
            ></isceco-text-input>
            <isceco-button variant="danger" icon="minus"
                           @click="${() => this._removePropertyStreet(index)}"
                           style="display: ${this.preview ? 'none' : 'block'}; margin-top: 23px"
            ></isceco-button>
          </div>
        `)}
        <div class="single-line">
          <isceco-number-input label="${this.i18n.translate('form.input.property.zip')}"
                               name="property.zipCode"
                               required
                               min="1000"
                               max="9999"
                               maximum-fraction-digits="0"
                               .readonly="${this.preview}"
          ></isceco-number-input>
          <isceco-text-input label="${this.i18n.translate('form.input.property.city')}"
                             name="property.city"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 1"
          ></isceco-text-input>
        </div>
        <isceco-number-input label="${this.i18n.translate('form.input.property.numberOfFlats')}"
                             name="property.numberOfFlats"
                             min="0"
                             max="9999"
                             maximum-fraction-digits="0"
                             .readonly="${this.preview}"
        ></isceco-number-input>
      </isceco-card>

      <isceco-card text="${this.i18n.translate('form.title.request')}" class="form-card">
        <div class="single-line">
          <isceco-dropdown label="${this.i18n.translate('form.input.request.type')}"
                           name="request.type"
                           required
                           .readonly="${this.preview}"
                           .i18n="${this.i18n}"
                           .items="${this._getRequestTypes()}"
                           @change="${this._toggleRequestOptionalFields}"
                           style="width: 100%"
          ></isceco-dropdown>
          <isceco-dropdown label="${this.i18n.translate('form.input.request.organisation')}"
                           name="request.organisation"
                           required
                           .readonly="${this.preview}"
                           .i18n="${this.i18n}"
                           .items="${[{value: 'WBG', name: 'form.input.request.organisation.WBG'}, {value: 'WS', name: 'form.input.request.organisation.WS'}]}"
                           style="width: 100%"
          ></isceco-dropdown>
        </div>
        <div id="request-optional-elements" class="form-card hidden">
          <div class="single-line">
            <isceco-number-input label="${this.i18n.translate('form.input.request.loanAmount')}"
                                 name="request.loanAmount"
                                 min="0"
                                 maximum-fraction-digits="0"
                                 .formatOptions="${{useGrouping: 'always'}}"
                                 .readonly="${this.preview}"
                                 style="width: 100%"
            ></isceco-number-input>
            <isceco-text-input label="${this.i18n.translate('form.input.request.requestNo')}"
                               name="request.requestNo"
                               required
                               .readonly="${this.preview}"
                               style="width: 100%"
            ></isceco-text-input>
          </div>
          <div class="single-line">
            <isceco-text-input label="${this.i18n.translate('form.input.request.contactPersonFirstname')}"
                               name="request.contactPersonFirstname"
                               required
                               .readonly="${this.preview}"
                               style="width: 100%"
            ></isceco-text-input>
            <isceco-text-input label="${this.i18n.translate('form.input.request.contactPersonLastname')}"
                               name="request.contactPersonLastname"
                               required
                               .readonly="${this.preview}"
                               style="width: 100%"
            ></isceco-text-input>
          </div>
          <isceco-text-input label="${this.i18n.translate('form.input.request.contactPersonEmail')}"
                             name="request.contactPersonEmail"
                             type="email"
                             pattern-error-text="${this.i18n.translate('form.input.request.contactPersonEmail.format')}"
                             required
                             .readonly="${this.preview}"
          ></isceco-text-input>
        </div>
        <isceco-textarea label="${this.i18n.translate('form.input.request.comment')}"
                         name="request.comment"
                         rows="3"
                         .readonly="${this.preview}"
        ></isceco-textarea>
      </isceco-card>

      ${this._renderAttachments()}
    `
  }

  _renderAttachments = () => {
    const label = this.i18n.translate('form.input.attachment')
    return html`
      <isceco-card text="${this.i18n.translate('form.title.attachments.request')}" class="form-card">
        <span style="font-style: italic">${this.i18n.translate('form.text.attachments.request')}</span>
        <isceco-file-input label="${label}"
                           name="requestAttachments"
                           multiple
                           maxfiles="25"
                           maxsize="${this.fileMaxSize}"
                           .fileInputService="${this.fileInputService}"
                           .disabled="${this.preview}"
        ></isceco-file-input>
      </isceco-card>

      <isceco-card text="${this.i18n.translate('form.title.attachments.legal')}" class="form-card">
        <span style="font-style: italic">${this.i18n.translate('form.text.attachments.legal')}</span>
        <isceco-file-input label="${label}"
                           name="legalAttachments"
                           multiple
                           maxfiles="25"
                           maxsize="${this.fileMaxSize}"
                           .fileInputService="${this.fileInputService}"
                           .disabled="${this.preview}"
        ></isceco-file-input>
      </isceco-card>

      <isceco-card text="${this.i18n.translate('form.title.attachments.entity')}" class="form-card">
        <span style="font-style: italic">${this.i18n.translate('form.text.attachments.entity')}</span>
        <isceco-file-input label="${label}"
                           name="entityAttachments"
                           multiple
                           maxfiles="25"
                           maxsize="${this.fileMaxSize}"
                           .fileInputService="${this.fileInputService}"
                           .disabled="${this.preview}"
        ></isceco-file-input>
      </isceco-card>

      <isceco-card text="${this.i18n.translate('form.title.attachments.plans')}" class="form-card">
        <span style="font-style: italic">${this.i18n.translate('form.text.attachments.plans')}</span>
        <isceco-file-input label="${label}"
                           name="planAttachments"
                           multiple
                           maxfiles="25"
                           maxsize="${this.fileMaxSize}"
                           .fileInputService="${this.fileInputService}"
                           .disabled="${this.preview}"
        ></isceco-file-input>
      </isceco-card>

      <isceco-card text="${this.i18n.translate('form.title.attachments.certification')}" class="form-card">
        <span style="font-style: italic">${this.i18n.translate('form.text.attachments.certification')}</span>
        <isceco-file-input label="${label}"
                           name="certificationAttachments"
                           multiple
                           maxfiles="25"
                           maxsize="${this.fileMaxSize}"
                           .fileInputService="${this.fileInputService}"
                           .disabled="${this.preview}"
        ></isceco-file-input>
      </isceco-card>

      <isceco-card text="${this.i18n.translate('form.title.attachments.other')}" class="form-card">
        <span style="font-style: italic">${this.i18n.translate('form.text.attachments.other')}</span>
        <isceco-file-input label="${label}"
                           name="otherAttachments"
                           multiple
                           maxfiles="25"
                           maxsize="${this.fileMaxSize}"
                           .fileInputService="${this.fileInputService}"
                           .disabled="${this.preview}"
        ></isceco-file-input>
      </isceco-card>
    `
  }

  _getRequestTypes = () => {
    return [
      {value: 'ERNEUERUNG', name: 'form.input.request.type.ERNEUERUNG'},
      {value: 'ERWERB', name: 'form.input.request.type.ERWERB'},
      {value: 'NEUBAU', name: 'form.input.request.type.NEUBAU'},
      {value: 'VORABKLAERUNG', name: 'form.input.request.type.VORABKLAERUNG'}
    ]
  }

  _addPropertyStreet = () => {
    if (this.propertyAddedStreets.length < 4) {
      this.propertyAddedStreets.push({renderId: crypto.randomUUID()})
      this.render()
    }
  }

  _removePropertyStreet = index => {
    this.propertyAddedStreets.splice(index, 1)
    this.render()
  }

  _toggleRequestOptionalFields = () => {
    const type = this.querySelector('isceco-dropdown[name="request.type"]').value
    if (!type || type === 'VORABKLAERUNG') {
      this.querySelector('#request-optional-elements').classList.add('hidden')
    } else {
      this.querySelector('#request-optional-elements').classList.remove('hidden')
    }
  }

  _submit = event => {
    if (!this.preview) {
      this.preview = true
      this.render()
      return
    }

    const json = this._prepareJson(event.detail)
    new FDRService().submit(json, event.target)
  }

  _prepareJson = form => {
    const json = form

    // configure added streets
    this.propertyAddedStreets.forEach((x, i) => {
      json.property[`street${i + 2}`] = json.property[`street${x.renderId}`]
      json.property[`houseNo${i + 2}`] = json.property[`houseNo${x.renderId}`]
      delete json.property[`street${x.renderId}`]
      delete json.property[`houseNo${x.renderId}`]
    })
    this.propertyAddedStreets = []

    return json
  }
}
customElements.define('eform-frontend-wbf-bwo-fdr', FDR)
